import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useWebgate } from "@xvia/webgate-connect";
import { Navigate } from "react-router-dom";
export function RequireAuth({ children }) {
    const { accessToken, initialized } = useWebgate();
    if (initialized && !accessToken) {
        return _jsx(Navigate, { to: "/nao-autorizado", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
